import { useState } from "react";
import BuyForm from "./BuyForm";
import SellForm from "./SellForm";
import BankAccountForm from "./BankAccountForm";
import OrderSummary from "./OrderSummary";

const OrderForm = () => {
  const [activeTab, setActiveTab] = useState("buy");
  const [showOrderSummary, setShowOrderSummary] = useState(false);
  const [, setCurrency] = useState("");
  const [formData, setFormData] = useState({});
  const [prevViews, setPrevViews] = useState<string[]>([]);

  const goBack = () => {
    if (prevViews.length > 0) {
      const lastView = prevViews.pop();
      setPrevViews([...prevViews]);
      if (lastView === "buy") {
        setShowOrderSummary(false);
      }
    }
  };

  return (
    <div className="min-h-screen flex flex-col md:space-x-8" data-testid="container-form-container">
      <div className="md:px-12" data-testid="container-form-header">
        <h1 className="text-2xl md:text-3xl font-normal text-left mb-4" data-testid="container-form-title">OTC</h1>
        <p className="text-sm md:text-base dark:text-white text-left mb-4" data-testid="container-form-description">
          Personalized service for $10K+ transactions
        </p>
      </div>

      <div className="sticky top-0 px-4 z-20 border-b dark:border-white" data-testid="container-form-tabs-container">
        <div className="flex flex-wrap space-x-4 md:space-x-12 text-2xl md:text-3xl font-normal">
          {[
            { key: "buy", label: "Buy" },
            { key: "sell", label: "Sell" },
            { key: "bankAccount", label: "Bank Account" },
          ].map(({ key, label }) => (
            <button
              key={key}
              onClick={() => {
                setActiveTab(key);
                setShowOrderSummary(false);
                setPrevViews([]);
              }}
              className={`pb-2 ${
                activeTab === key || (key === "buy" && showOrderSummary)
                  ? "border-b-2 border-clementine dark:border-sun"
                  : "text-gray-500"
              }`}
              data-testid={`order-form-tab-${key}`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex-1 overflow-visible p-1 md:p-10" data-testid="container-form-content">
        {showOrderSummary && (
          <button
            onClick={goBack}
            className="mb-4 text-lg font-medium dark:text-white hover:underline"
            data-testid="container-summary-back-button"
          >
            ← Back
          </button>
        )}
        {showOrderSummary ? (
          <OrderSummary
            setShowOrderSummary={(show) => {
              if (show) setPrevViews((prev) => [...prev, "buy"]);
              setShowOrderSummary(show);
            }}
            formData={formData}
          />
        ) : (
          <form className="space-y-8" data-testid="form-order">
            {activeTab === "buy" && (
              <BuyForm
                setCurrency={setCurrency}
                setShowOrderSummary={(show) => {
                  if (show) setPrevViews((prev) => [...prev, "buy"]);
                  setShowOrderSummary(show);
                }}
                setFormData={setFormData}
              />
            )}
            {activeTab === "sell" && (
              <SellForm
                setCurrency={setCurrency}
                onAddBankAccount={() => setActiveTab("bankAccount")}
              />
            )}
            {activeTab === "bankAccount" && <BankAccountForm />}
          </form>
        )}
      </div>
    </div>
  );
};

export default OrderForm;

/*
POTENTIAL IMPROVEMENTS:
1. Add form validation for all input fields
2. Implement proper form state management with React hook form
3. Add loading states during form submission
4. Improve form navigation with breadcrumbs
5. Add form progress indicator for multi-step forms
6. Implement proper error handling with user feedback
7. Add confirmation dialogs for important actions
8. Improve accessibility with proper ARIA attributes
9. Add keyboard navigation support
10. Consider implementing a more robust state management solution
11. Add responsive design improvements for mobile devices
12. Implement proper form reset functionality
13. Add auto-save functionality for form data
14. Consider adding form analytics for user behavior tracking
15. Implement proper focus management for improved UX
*/
